import {
  extraNode,
  parseThreeEndStyle,
  parseUrl,
  updateRootStyle,
  walkNode
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'

import { walkAllMetaComponentList } from '@/components/common/controlBar/controlBarDialog/metaComponent/worker.js'
import { pageInfoApi, templateInfoApi } from './api/pageInfo.js'
import { getDefaultGlobalPopagationValues } from '@/globalPopagation'
import http from '@/mm/http.js'
import store from './store/index'
import { emptyDataStructure, TEXT_REMARK_MAP } from '@/consts/base.js'

export function mapTree(arr, childrenKey, callback) {
  var newArr = []
  arr.forEach((item) => {
    var newItem = callback(item)
    newArr.push(newItem)
    if (item[childrenKey] && item[childrenKey].length) {
      newItem[childrenKey] = mapTree(item[childrenKey], childrenKey, callback)
    }
  })
  return newArr
}

function countNodesLength(node) {
  let count = 0
  walkNode(node, () => {
    count++
  })
  return count
}

export function isNodeExsit(node) {
  var res = false
  walkNode(
    {
      list: mm.store.state.hasList
    },
    (walkedNode) => {
      if (node.cacheKey === walkedNode.cacheKey) {
        res = true
      }
    }
  )
  return res
}

self.isNodeExsit = isNodeExsit

export function reRender(node, nodeConstructor, needReRender) {
  return new Promise((resolve) => {
    let countTime = 0
    let isExcuted = false
    let timer = null
    window.countRecord = 0
    let allLength = countNodesLength(nodeConstructor[0])
    timer = setInterval(() => {
      if (isExcuted) return
      countTime++
      if (window.countRecord === allLength || countTime === 10) {
        isExcuted = true
        resolve()
        clearInterval(timer)
        timer = null
      }
    }, 100)
    if (Object.prototype.toString.call(nodeConstructor) === '[object Array]') {
      node.list = nodeConstructor.map((item) => {
        return extraNode(item)
      })
    } else {
      node.list = extraNode(nodeConstructor)
    }

    if (needReRender) {
      node.cacheKey = Date.now()
    }

    mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
    //mm.store.commit('EMPTY_DIALOG')
  })
}

export function getCurrentPageId() {
  var pageId = parseUrl(location.href).params.id
  if (!pageId) {
    // 没有， 默认是首页
    pageId = 1
  }
  return pageId
}

export function getCurrentPageType(pageId, pageList) {
  const page_type = mm.utils.getQueryParams({ key: 'page_type' })
  if (page_type !== undefined) return page_type
  var match = pageList.find((item) => {
    return item.id === Number(pageId)
  })
  if (match && match.page_type !== undefined) {
    return match.page_type
  }
  if (pageList[0].page_type !== undefined) {
    return pageList[0].page_type
  }
  return 1
}

export function getCurrentPage() {
  return mm.store.state.module.currentPage
}

export function getCurrentModule() {
  return mm.store.state.module.currentModule
}

export function getAuthInfo() {
  return mm.store.state.authInfo
}

export function isInModule() {
  return getAuthInfo().type === 'module'
}

export async function getPageInfoById(pageId = null, pagetype = null) {
  if (mm.store.state.authInfo.type === 'template') {
    const params = {
      a_ksh_template_id: mm.store.state.authInfo.foreign_id,
      page_id: pageId ? pageId : getCurrentPageId(),
      page_type: pagetype ? pagetype : getCurrentPageType(getCurrentPageId(), pageList)
    }
    const res = await templateInfoApi(params, false)
    return res
  } else if (
    mm.store.state.authInfo.type !== 'template' &&
    mm.store.state.authInfo.type !== 'module'
  ) {
    const params = {
      page_id: pageId ? pageId : getCurrentPageId(),
      page_type: pagetype ? pagetype : getCurrentPageType(getCurrentPageId(), pageList)
    }
    const res = await pageInfoApi(params, false)
    return res
  }
}

export function getBaseConfig(constructor) {
  return {
    name: constructor.name,
    componentName: constructor.componentName,
    _type: constructor._type,
    data: constructor.data
  }
}

export async function createFontsStyle(hasList) {
  var usedFonts = {}
  hasList.forEach((hasListItem) => {
    walkNode(hasListItem, (walkedNode) => {
      walkAllMetaComponentList(walkedNode, (walkedMetaComponent, parent) => {
        if (walkedMetaComponent.componentType === 'fontFamily') {
          for (var threeEndTypeKey in walkedMetaComponent.value['font-family']) {
            var font = walkedMetaComponent.value['font-family'][threeEndTypeKey]
            usedFonts[font] = true
          }
        }
      })
    })
  })

  var { data } = await mm.http({
    url: '/api/font/list',
    method: 'get'
  })

  var fontList = data.list

  var globalFont = fontList.find((fontItem) => {
    return (
      fontItem.id ===
      (mm.store.state.authInfo.a_ksh_font_id === 0 ? 68 : mm.store.state.authInfo.a_ksh_font_id)
    )
  })
  usedFonts[globalFont.name] = true
  fontList = fontList.filter((fontItem) => {
    var arr = Object.keys(usedFonts)
    return arr.includes(fontItem.name)
  })

  var fontsStyle = ''
  fontList.forEach((font) => {
    fontsStyle += `
          @font-face {
            font-family: '${font.name}';
            src: url('${font.url}') format('truetype');
            font-weight: normal;
            font-style: normal;
            font-display: swap;
          }
        `
  })
  fontsStyle = mm.utils.compressCSS(fontsStyle)

  return fontsStyle
}


export async function createPostStructor(hasList, fontsStyle, commonStyles){
  return {
    content: mm.utils.extractFields([hasList[1]])[0],
    header_content: mm.utils.extractFields([hasList[0]])[0],
    footer_content: mm.utils.extractFields([hasList[2]])[0],
    styles: `${mm.utils.compressCSS(await parseThreeEndStyleOfContent(false,'page', null, false))}${fontsStyle}`,
    styles_rtl: `${mm.utils.compressCSS(await parseThreeEndStyleOfContent(false, 'page', null, true))}${fontsStyle}`,
    header_styles: `${mm.utils.compressCSS(commonStyles.default)}${mm.utils.compressCSS(await parseThreeEndStyleOfHeader(false, false))}`,
    header_styles_rtl: `${mm.utils.compressCSS(commonStyles.default)}${mm.utils.compressCSS(await parseThreeEndStyleOfHeader(false, true))}`,
    footer_styles: `${mm.utils.compressCSS(await parseThreeEndStyleOfFooter(false, false))}`,
    footer_styles_rtl: `${mm.utils.compressCSS(await parseThreeEndStyleOfFooter(false, true))}`,
  }
}



export async function save(type = 'page', hasListVal, infoVal, isShowSuccess = true, skipLoading = false) {
  return new Promise(async (resolve) => {
    const hasList = type === 'page' ? mm.store.state.hasList : hasListVal

    if (hasList[1] && hasList[1].list) {
      hasList[1].list = hasList[1].list.filter((item) => {
        if (item.flag === 'globalPopagation') {
          return false
        } else {
          return true
        }
      })
    }

    // 动态加载 Sass 文件内容
    if(!window.commonStyles){
      window.commonStyles = await import('./components/styles.scss?inline')
    }
    const commonStyles = window.commonStyles


    var fontsStyle = await createFontsStyle(hasList)

    if (mm.store.state.authInfo.type === 'module') {
      mm.http({
        url: '/ksh/module/editPost',
        method: 'post',
        loading: !skipLoading,
        data: {
          ...getCurrentModule(),
          styles: `${mm.utils.compressCSS(await parseThreeEndStyle(false, [hasList[0]]))}${fontsStyle}`,
          content: mm.utils.extractFields([hasList[0]])[0]
        }
      })
        .then((data) => {
          if (data.code === 200) {
            isShowSuccess && mm.toast('保存模块成功', 'success', 2000)
            mm.oldHasList = JSON.parse(JSON.stringify(mm.store.state.hasList))
            setTimeout(() => {
              import('./utils/operationLog.js').then(({ reportOperationLogs, REPORT_TYPES }) => {
                reportOperationLogs(REPORT_TYPES.SAVE).catch(console.error)
              })
            }, 100)
          }
          resolve()
        })
        .catch((e) => {
          resolve()
        })
    } else if (mm.store.state.authInfo.type === 'template') {
      mm.http({
        url: '/ksh/template/page/save',
        method: 'post',
        loading: !skipLoading,
        data:
          type === 'page'
            ? {
                ...getCurrentPage(),
                ...await createPostStructor(hasList, fontsStyle, commonStyles),
              }
            : {
                ...infoVal,
                ...await createPostStructor(hasList, fontsStyle, commonStyles),
              }
      })
        .then((data) => {
          if (data.code === 200) {
            isShowSuccess && mm.toast('保存模板页面成功', 'success', 2000)
            mm.oldHasList = JSON.parse(JSON.stringify(mm.store.state.hasList))
            setTimeout(() => {
              import('./utils/operationLog.js').then(({ reportOperationLogs, REPORT_TYPES }) => {
                reportOperationLogs(REPORT_TYPES.SAVE).catch(console.error)
              })
            }, 100)
          }
          resolve()
        })
        .catch((e) => {
          resolve()
        })
    } else {
      mm.http({
        url: '/ksh/page/save',
        method: 'post',
        loading: !skipLoading,
        data:
          type === 'page'
            ? {
                ...getCurrentPage(),
                // a_ksh_font_id: mm.store.state.authInfo.a_ksh_font_id,
                ...await createPostStructor(hasList, fontsStyle, commonStyles),
              }
            : {
                ...infoVal,
                // a_ksh_font_id: mm.store.state.authInfo.a_ksh_font_id,
                ...await createPostStructor(hasList, fontsStyle, commonStyles),
            }
      }).then((data) => {
        if (data.code === 200) {
          isShowSuccess && mm.toast('保存页面成功', 'success', 2000)
          mm.oldHasList = JSON.parse(JSON.stringify(mm.store.state.hasList))
          setTimeout(() => {
            import('./utils/operationLog.js').then(({ reportOperationLogs, REPORT_TYPES }) => {
              reportOperationLogs(REPORT_TYPES.SAVE).catch(console.error)
            })
          }, 100)
        }
        resolve()
      }).catch((e)=>{
        resolve()
      })
    }
    const layout = mm.utils.getQueryParams({ key: 'layout' })
    var url = new URL(window.location.href)
    var params = new URLSearchParams(url.search)
    params.set('layout', '')
    url.search = params.toString()
    history.replaceState(null, '', url.href)
  })
}

export const initAuthInfo = (info, fontList, store) => {
  info.ksh_global_theme_color.popagation  = handlePagination(info)
  if(!info.ksh_global_theme_color.hasOwnProperty('pcResponse')){
    info.ksh_global_theme_color.pcResponse  = true
    window.defaultEnablePcResponse = true
  }

  if(!info.ksh_global_theme_color.hasOwnProperty('isForceEnableArabicContext')){
    info.ksh_global_theme_color.isForceEnableArabicContext  = false
  }


  info.a_ksh_font_id = handleGlobalFont(info)
  info.ksh_global_theme_color = handleTheme(info.ksh_global_theme_color, fontList, info.a_ksh_font_id)
  info.mediaQueryConfig = [
    {
      start: '2201px',
      end: '2920px',
      percent: '130%'
    },
    {
      start: '1921px',
      end: '2200px',
      percent: '115%'
    },
    {
      start: '1460px',
      end: '1920px',
      percent: '100%'
    },
    {
      start: '1260px',
      end: '1459px',
      percent: '95%'
    },
    {
      start: '992px',
      end: '1259px',
      percent: '90%'
    },
    // {
    //   start: '1121px',
    //   end: '991px',
    //   percent: '75%'
    // },
    // {
    //   start: '991px',
    //   end: '1120px',
    //   percent: '70%'
    // }
  ]
  store.commit('UPDATE_AUTH_INFO', info)
  updateRootStyle(info.ksh_global_theme_color)
}


export function getCurrentLanguage(initLanguageId){
  var currentLanguage = parseUrl(location.href).params.languageId
  if (currentLanguage) {
    return Number(currentLanguage)
  } else {
    return Number(initLanguageId)
  }
}

function handleTheme(themeInfo = {}, fontList, fontId) {
  const params = {
    ksh_global_theme_color: {
      color: {},
      text: [],
      fontFamily: '',
      fontFaces: [],
      anchorTextColor: ''
    }
  }
  let isHaveColor = true
  let isHaveText = true
  let isHaveFontFamily = true
  let isHaveFontFace = true
  let isHaveAnchorTextColor = true
  const {
    color: resColor = {},
    text: resText = [],
    fontFamily: resFontFamily = '',
    fontFaces: resFontFaces = [],
    anchorTextColor: resAnchorTextColor = ''
  } = themeInfo
  const {
    ksh_global_theme_color: { color = {}, text = [], fontFamily = '', anchorTextColor = '' }
  } = store.state.authInfo
  if (!resColor || Array.isArray(resColor) || Object.keys(resColor).length < 6) {
    isHaveColor = false
    params.ksh_global_theme_color.color = color
  } else {
    params.ksh_global_theme_color.color = resColor
  }
  if (!resText || resText?.length < 6) {
    isHaveText = false
    params.ksh_global_theme_color.text = dealText(text)
  } else {
    params.ksh_global_theme_color.text = dealText(resText)
  }
  if (!resFontFamily) {
    isHaveFontFamily = false
    const font = fontList.find((v) => v.id === fontId)
    params.ksh_global_theme_color.fontFamily = font?.name || ''
  } else {
    params.ksh_global_theme_color.fontFamily = resFontFamily
  }
  if (!resFontFaces || resFontFaces?.length < 1) {
    isHaveFontFace = false
    const fontIds = Array.from(new Set([...resText.map((item) => item.fontFamilyId), fontId]))
    params.ksh_global_theme_color.fontFaces = fontList.filter((item) => fontIds.includes(item.id))
  } else {
    params.ksh_global_theme_color.fontFaces = resFontFaces
  }
  if(!resAnchorTextColor) {
    isHaveAnchorTextColor = false
    params.ksh_global_theme_color.anchorTextColor = resColor.dominantColor ? resColor.dominantColor : 'rgb(0, 92, 179)'
  } else {
    params.ksh_global_theme_color.anchorTextColor = resAnchorTextColor
  }
  params.ksh_global_theme_color.pcResponse = themeInfo.pcResponse
  params.ksh_global_theme_color.isForceEnableArabicContext = themeInfo.isForceEnableArabicContext
  params.ksh_global_theme_color.popagation = themeInfo.popagation

  if (!isHaveColor || !isHaveText || !isHaveFontFamily || !isHaveFontFace || !isHaveAnchorTextColor) {
    http({
      url: '/ksh/updateGlobalThemeColor',
      method: 'post',
      data: params
    })
  }
  return params.ksh_global_theme_color
}
function dealText(text) {
  return text.map((item) => {
    if (!item.remark && TEXT_REMARK_MAP.has(item.id)) {
      return {
        ...item,
        remark: TEXT_REMARK_MAP.get(item.id)
      }
    }
    return {
      ...item,
      remark: item?.remark || ''
    }
  })
}
function handleGlobalFont(info) {
  if (!info.a_ksh_font_id) {
    info.a_ksh_font_id = 68
    http({
      url: '/ksh/updateGlobalFont',
      method: 'post',
      loading: false,
      data: { a_ksh_font_id: 68 }
    })
  }
  return info.a_ksh_font_id
}
function handlePagination(info) {
  if (info.ksh_global_theme_color.popagation) {
    var json = getDefaultGlobalPopagationValues()
    for (var key in json.design) {
      if (!info.ksh_global_theme_color.popagation.design[key]) {
        info.ksh_global_theme_color.popagation.design[key] = json.design[key]
      }
    }
    for (var key in json.hover) {
      if (!info.ksh_global_theme_color.popagation.hover[key]) {
        info.ksh_global_theme_color.popagation.hover[key] = json.hover[key]
      }
    }

    return info.ksh_global_theme_color.popagation
  } else {
    return getDefaultGlobalPopagationValues()
  }
}
export const editCommon = (item) => {
  const { hasList, module: {currentPage}, isEditCommon } = mm.store.state
  mm.confirm('温馨提示', '需要保存当前页面的修改吗？', async () => {
    if(!isEditCommon) {
      await save()
    }
    enterEditCom(item)
  }, ()=> {
    enterEditCom(item)
  }, ()=> {},'保存', '不保存')
}
export const enterEditCom = (item)=> {
  let resList = []
  const isCommonModule = item.list?.[0]?.isCommon && item.list?.[0]?.componentName === 'module'
  if (isCommonModule) {
    resList = [
      extraNode({
        name: '页面',
        startNode: true,
        componentName: 'content',
        _type: 'bodyBase',
        list: item.list
      })
    ]
  } else {
    resList = [
      extraNode(emptyDataStructure(item.list))
    ]
  }

  const data = { id: item.id, name: item.name, type: item.type }
  mm.utils.formatListName(resList)
  mm.store.commit('UPDATE_IS_EDIT_COMMON', true)
  mm.store.commit('UPDATE_CURRENT_COMMON', data)
  mm.store.commit('UPDATE_HAS_LIST', resList)
  mm.store.commit('EMPTY_DIALOG')
}
export function styleToClass(styleStr) {
  if (!styleStr || typeof styleStr !== 'string') {
    return ''
  }
  const styleToClassMap = {
    'display': (value) => {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === 'flex') return 'w-flex'
      return null
    },
    'flex-direction': (value) => {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === 'column') return 'w-flex-col'
      return null
    },
    'justify-content': (value) => {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === 'center') return 'w-justify-center'
      if (normalizedValue === 'flex-end') return 'w-justify-end'
      if (normalizedValue === 'space-between') return 'w-justify-between'
      if (normalizedValue === 'flex-start') return 'w-justify-start'
      return null
    },
    'align-items': (value) => {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === 'flex-start') return 'w-items-start'
      if (normalizedValue === 'center') return 'w-items-center'
      if (normalizedValue === 'flex-end') return 'w-items-end'
      return null
    },
    'flex': (value) => {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === '1 1 0%' || normalizedValue === '1') return 'w-flex-1'
      if (normalizedValue === '1 0 80px') return 'w-flex-80'
      return null
    },
    'flex-wrap': (value) => {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === 'wrap') return 'w-flex-wrap'
      if (normalizedValue === 'nowrap') return 'w-flex-nowrap'
      return null
    },
    'width': (value)=> {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === '100%') return 'w-w-full'
      return null
    },
    'max-width': (value)=> {
      const normalizedValue = value.trim().toLowerCase()
      if (normalizedValue === '100%') return 'w-m-width-100'
      return null
    }
  }
  const classes = []
  const stylePairs = styleStr.split(';')
  for (const pair of stylePairs) {
    const [prop, value] = pair.split(':').map(s => s.trim())
    if (prop && value && styleToClassMap[prop]) {
      const className = styleToClassMap[prop](value)
      if (className) {
        classes.push(className)
      }
    }
  }
  return classes.join(' ')
}
